export default {
  backToHome: 'Back to home',

  forbiddenTitle: 'Access denied',
  forbiddenMessage: "You don't have permission to see this page. Your access to this area has been restricted.",

  serverErrorTitle: 'Server error',
  serverErrorMessage: 'Something went wrong on our end. Our team has been notified — please try again in a moment.',

  serviceUnavailableTitle: 'Under maintenance',
  serviceUnavailableMessage:
    "PlayStock is temporarily offline for scheduled maintenance. We'll be back online shortly — thanks for your patience.",

  notFoundTitle: 'Page not found',
  notFoundMessage: "The page you're looking for doesn't exist or has been moved. Check the URL or head back home.",
};
